import { Component, OnInit, ViewChild  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client } from '../../../../classes/Client';
import { Project } from '../../../../classes/Project';
import { Rebate } from '../../../../classes/Rebate';
import { PROVINCES } from '../../../data/provinces';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import { ImagesService } from '../../../services/images.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-or-edit-project',
  templateUrl: './add-or-edit-project.html',
  styleUrls: ['./add-or-edit-project.scss']
})
export class AddOrEditProject implements OnInit {
  @ViewChild('select') selectElRef;

  id: number;
  isSubmitButtonDisabled: boolean = false;
  Project: Project = new Project();
  clientsList: Client[] = [];
  rebatesData: Rebate[] = [];
  title: string = '';
  provinces = PROVINCES;
  floorPlanName: string = '';
  availableRoles: string[] = ['admin', 'sales', 'manager'];
  isAvailable: boolean = true;
  rebatesTimeout: any;
  adminsData = [];
  addVideoButtonDisabled: boolean = true;
  permission: string = '';
  contentVisible: boolean = false;
  currentTax: string = '';
  currentTaxValue: any;
  taxChangeAvailable: boolean = true;
  hasNotes: boolean = false;
  notes: any[] = [];
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;
  usersData = [];

  selectParams: any = {
    comission_paid: {

      id: 'selectCommisionPaid',
      isRequired: true,
      change: ( event ) => {
        this.Project.comission_paid = event.value;
      },
      options: [
        { text: '', value: '' },
        { text: 'Yes', value: true },
        { text: 'No', value: 'false' }
      ]
    },
    sales: {
      id: 'selectSalesperson',
      isRequired: this.title === 'Add Project',
      change: ( event ) => {
        this.Project.Sales = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    state: {
      id: 'inputState',
      isRequired: true,
      change: ( event ) => {
        this.Project.State = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    owner: {
      id: 'selectOwner',
      isRequired: this.title === 'Add Project',
      change: ( event ) => {
        this.Project.owner = event.value;
      },
      options: [ { text: '', value: '' } ]
    },
    customer: {
      id: 'inputCustomer',
      isRequired: this.title === 'Add Project',
      change: ( event ) => {
        this.Project.Customer = event.value;
        this.changeCustomer( );
      },
      options: [ { text: '', value: '', title: '' } ]
    },
    jobType: {
      id: 'selectJobType',
      isRequired: true,
      change: ( event ) => {
        this.Project.jobType = event.value;
      },
      options: [
        { text: '', value: '' },
        { text: 'Repair', value: 'repair' },
        { text: 'Retrofit', value: 'retrofit' },
        { text: 'Non-retrofit', value: 'newInstall' },
      ]
    },
    status: {
      id: 'inputStatus',
      isRequired: true,
      change: ( event ) => {
        this.Project.status = event.value;
      },
      options: [
        { text: '', value: '' } ]
    },
    buildingType: {
      id: 'selectBuildingType',
      isRequired: true,
      change: ( event ) => {
        this.Project.BuildingType = event.value;
      },
      options: [
        { text: '', value: '' },
        { text: 'Bank', value: 'bank' },
        { text: 'Commercial building', value: 'commercialBuilding' },
        { text: 'Educational institution', value: 'educationalInstitution' },
        { text: 'Hospitality', value: 'hospitality' },
        { text: 'Hospital / Healthcare', value: 'hospitalHealthcare' },
        { text: 'Mass transit', value: 'massTransit' },
        { text: 'Parking lot', value: 'parkingLot' },
        { text: 'Residential building', value: 'residentialBuilding' },
        { text: 'Restaurant', value: 'restaurant' },
        { text: 'Retail store', value: 'retailStore' },
        { text: 'Supermarket', value: 'supermarket' },
        { text: 'Warehouse', value: 'warehouse' },
        { text: 'Other', value: 'other' }
      ]
    },
  }


  datepickerDeadlineOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    placeholder: ''
  };

  _date_deadline: any = '';
  _old_deadline: any = ''
  _was_matched_deadline: boolean = false;

  constructor (
    private route: ActivatedRoute,
    private model: ModelService,
    public global: GlobalService,
    public cropper: ImagesService,
    private alerts: AlertsService,
    private loginService: LoginService
  ) {
    this.title = 'Add Project';
    this.route.params.subscribe((params) => {
        this.generateSelectOptions( );
      if( params.id ) {
        this.title = 'Edit Project';
        this.id = params.id;

        this.model.getUsersData( ( usersData ) => {
          usersData = usersData.json( );
          if ( usersData.users ) {
            this.usersData = usersData.users;
            this.usersData.forEach( _user => {
              this.selectParams.sales.options.push( { text: _user.firstName+' '+_user.secondName ,value: _user.id } );
            });
          }
        }, { status: 'active', not_empty_name: 'true' });
      }
    });

    this.isAvailable = this.availableRoles.indexOf(this.loginService.userInfo.role) !== -1;
    this.provinces.forEach( _state => {
      this.selectParams.state.options.push( { text: _state.long, value: _state.short } );
    });
  }

  ngOnInit ( ) {
    this.Project.InstallationCost = '';
    this.Project.InstallationCostA = '';
    this.Project.InstallationCostB = '';
    this.Project.InstallationCostC = '';
  }

  ngAfterViewInit ( ) {
    // this.getRebatesData( );
    let _discount:number = 0;
    let _tax:number = 0;

    this.model.getClientsData( ( data ) => {
      this.global.hidePreloader( ).subscribe( );
      this.clientsList = data;
      data.forEach( _client => {
        this.selectParams.customer.options.push( { text: _client.FirstName+' '+_client.LastName ,value: _client.id, title: _client.Company } );
      });

      if( this.title === 'Edit Project' ) {
        this.model.getProjectDataByID( this.id, ( project, permission ) => {
          // if ( project == 'NotAllowed' ) {
          //   this.contentVisible = true;
          //   this.isAvailable = false;
          //   this.global.redirect( '/projects-list' );
          // } else {
          this.permission = permission;
          this.contentVisible = true;
          project.Notes = '';
          this.Project = project;
          this.Project.id = this.id;
          this.currentTaxValue = project.tax_id;
          if (project.floorPlan) this.floorPlanName = project.floorPlan.substring(project.floorPlan.lastIndexOf('/')+1);
          if ( this.Project.deadline || this.Project.deadline === '' ) {
            this._date_deadline = this.global.parseDate( this.Project.deadline );
          }
          if ( this.Project.comission_paid === 0 ) {
            this.Project.comission_paid = 'false';
          }
          this.getRebatesData( );
          this.checkVideos( );
          this.checkTaxChangeAvailability( );
          this.getCurrentTax( );

          this.selectParams.status.isDisabled = ( this.loginService.userInfo.role != 'admin' && (this.Project.status == 'projectCompleted'  ||  this.Project.status == 'projectCancelled') ) ||  this.Project.status == 'projectCompletedRMARGA';

          if ( project.Discount ) _discount = +project.Discount;
          if ( project.Tax ) _tax = +project.Tax;
          if ( _discount == 0 ) delete this.Project.Discount;
          if ( _tax == 0 ) delete this.Project.Tax;
          this.getNotes( );
          // }
        });
      }
    }, undefined, true );


    this.model.getUsersData( ( usersData ) => {
      usersData = usersData.json( ).users;
      this.adminsData = usersData;
      usersData.forEach( _ad => { this.selectParams.owner.options.push( { text: _ad.firstName + ' ' + _ad.secondName, value: _ad.id } ); });
    });
  }

  addNote ( ) {
    this.model.addNote( 'project', this.id, this.Project.Notes, ( response ) => {
      this.getNotes( );
      this.isRequiredNotesField = false;
      this.isNotesWasEdited = true;
    });
  }

  showHistory ( ) { this.global.changeHPVisibility( true ); }

  deleteImage ( inputFile, public_id ) {
    inputFile.value = '';
    this.cropper.destroyImage( public_id, ( ) => {
      this.Project.attachment = '';
      this.Project.attachment_public_id = '';
    });
  }

  checkTaxChangeAvailability ( ) {
    if ([
      "paidInFull",
      "installationPending",
      "installationCompleted",
      "projectCompleted",
      "projectCompletedRMARGA",
      "projectCancelled"
    ].indexOf( this.Project.status ) !== -1 ) {
      this.Project.tax_id = this.currentTaxValue;
      this.taxChangeAvailable = false;
    } else {
      this.taxChangeAvailable = true;
    }
  }

  getCurrentTax ( ) {
    this.model.getProjectCurrentTax( this.Project.tax_id ).then( ( response:any ) => {
      if ( response.tax ) {
        this.currentTax = response.tax.State+' ('+response.tax.percent+'%)';
      }
    });
  }

  getNotes ( ) {
    this.model.getNotes( 'project', this.id, ( notes ) => {
      this.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  updateSelectList( ) {
    let options = this.selectElRef.nativeElement.options;
    for ( let i = 0; i < options.length; i++ ) {
      options[i].selected = this.Project.Rebates.indexOf( options[i].value ) > -1;
    }
  }

  changeCustomer (  ) {
    this.model.getClientDataByID( this.Project.Customer, ( client ) => {
      this.Project.Contact        = client.FirstName + ' ' + client.LastName;
      this.Project.Street         = client.ShippingStreet.toString( ).replace(/\n/g, " ");
      this.Project.City           = client.ShippingCity;
      this.Project.State          = client.ShippingState;
      this.Project.ZipCode        = client.ShippingZipCode;
      this.Project.Country        = client.ShippingCountry;
      this.Project.PhoneNumber    = client.Phone;
      this.Project.Email          = client.Email;
      this.Project.Position       = client.Position;
    });
    this.getRebatesData( false, true );
  }

  getRebatesData ( withTimeout?, selectFirstRebate? ) {
    let _params = {
      'showAll': true,
      'active': true,
      'sorting': 'rebates.name',
      'custom': !!this.Project.customRebates,
      'client_id': this.Project.Customer,
    };
    if ( withTimeout == true ) {
      clearTimeout( this.rebatesTimeout );
      this.rebatesTimeout = setTimeout( ( ) => {
        this.model.getRebatesData( ( rbData ) => {
          this.rebatesData = rbData;
          if ( selectFirstRebate == true ) {
            this.Project.Rebates = [];
            for ( let i = 0 ; i < this.rebatesData.length; ++i ) {
              this.Project.Rebates.push( this.rebatesData[i].id );
            }
          }
          this.updateSelectList( );
        }, _params);
      }, 300);
    } else {
      this.model.getRebatesData( ( rbData ) => {
        this.rebatesData = rbData;
        if ( selectFirstRebate == true ) {
          this.Project.Rebates = [];
          for ( let i = 0 ; i < this.rebatesData.length; ++i ) {
            this.Project.Rebates.push( this.rebatesData[i].id );
          }
        }
        this.updateSelectList( );
      }, _params);
    }
  }


  changeElectricBill ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    // formData.append( 'img', file, file.fileName );
    formData.append( 'img', file, this.Project.Name+"_"+file.name );
    // this.model.uploadElectricBill( formData, this.Project.Name, ( response ) => {
    this.model.uploadElectricBill( formData, ( response ) => {
      this.Project.electricBill = response.url;
      this.global.hidePreloader( );
    });
  }


  changeFloorPlan ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadFloorPlan( formData, file.fileName, ( response ) => {
      this.Project.floorPlan = response.url;
      this.floorPlanName = response.url.substring(response.url.lastIndexOf('/')+1);
      this.global.hidePreloader( );
    });
  }

  changeDocument ( $event ) {

    let file: any = $event.target.files[0];

    if ( !file ) return;

    this.global.showPreloader( );
    let formData = new FormData( );
    formData.append( 'pdf', file, file.fileName );
    this.model.uploadProjectDocument( formData, file.fileName, ( response ) => {
      this.Project.document = response.url;
      this.global.hidePreloader( );
    });
  }



  successCallback ( id ) {

    // edit project
    if( id === 0 ) {
      this.global.defaultSuccessMessage({
        html: 'Project information has been updated successfully',
        redirect: '/project-detail/'+this.id
      });
    }
    // add project
    else {
      this.global.defaultSuccessMessage({
        html: 'New project has been added successfully',
        redirect: '/project-detail/'+id
      });
    }
  }

  errorCallback ( message?: string ) {
    this.global.hidePreloader( ).subscribe( );
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;

  }


  submitForm ( ) {
    this.global.showPreloader( ).subscribe( );
    this.isSubmitButtonDisabled = true;

    this.Project.jobDetails = $( '#inputJobDetails' ).html( );
    this.Project.shippingDetails = $( '#inputShippingDetails' ).html( );

    if (this.Project.comission_paid === 'false') {
      this.Project.comission_paid = false;
    }

    if( this.title === 'Add Project' ) {
      if ( this.Project.InstallationCost == '' ) this.Project.InstallationCost = '-1';

      this.model.addProject( this.Project, ( response ) => {
        let _response = response.json( );
        let _answer = _response.answer;
        if ( _answer == 'success' ) this.successCallback( _response.id );
        else if ( _answer == 'exists' ) {
          this.errorCallback( 'Project with the name "' + this.Project.Name + '" already exists' );
          this.global.defaultErrorCallback( 'Project with the name "' + this.Project.Name + '" already exists' );
          this.Project.comission_paid = this.Project.comission_paid ? 'true' : false;
        }  else {
          this.errorCallback( _answer );
          this.global.defaultSuccessMessage( _answer );
          this.Project.comission_paid = this.Project.comission_paid ? 'true' : false;
        }
      });
    }
    else if( this.title === 'Edit Project' ) {
      if ( this.Project.InstallationCost == '' ) this.Project.InstallationCost = '-1';
      if ( this.Project.InstallationCostA == '' ) this.Project.InstallationCostA = '-1';
      if ( this.Project.InstallationCostB == '' ) this.Project.InstallationCostB = '-1';
      if ( this.Project.InstallationCostC == '' ) this.Project.InstallationCostC = '-1';

      // ToDo fix duplicated code add and edit
      this.model.editProject( this.Project, ( response ) => {
        let _answer = response.json( );
        _answer = _answer.answer;
        if ( _answer == 'success' ) this.successCallback( 0 );
        else if ( _answer == 'exists' ) {
          this.errorCallback( 'Project with the name "' + this.Project.Name + '" already exists' );
          this.global.defaultErrorCallback( 'Project with the name "' + this.Project.Name + '" already exists' );
          this.Project.comission_paid = this.Project.comission_paid ? 'true' : false;
        }  else {
          this.errorCallback( _answer );
          this.global.defaultSuccessMessage( _answer );
          this.Project.comission_paid = this.Project.comission_paid ? 'true' : false;
        }
      });
    }


    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/projects-list' );
  }

  generateSelectOptions ( ) {

      console.log('11111');

    this.selectParams.status.options = [
        { text: '', value: '' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "newLead", text: 'New lead' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "leadLost", text: 'Lead lost' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "pendingManagerApproval", text: 'Pending manager approval' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "managerApproved", text: 'Manager approved' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "proposalSent", text: 'Proposal sent' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "depositReceived", text: 'Deposit received' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "invoiceSent", text: 'Invoice sent' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "purchaseOrderSent", text: 'Purchase order sent' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "productsShipped", text: 'Products shipped' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "productsReceived", text: 'Products received' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "paidInFull", text: 'Paid in full' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "installationPending", text: 'Installation pending' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "installationCompleted", text: 'Installation completed' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager'), value: 'projectCompleted', text: 'Project completed' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager'), value: 'projectCompletedRMARGA', text: 'Project completed with RMA/RGA' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager'), value: 'projectCancelled', text: 'Project cancelled' },
        { disabled: (this.loginService.userInfo.role == 'sales' || this.loginService.userInfo.role == 'manager') && (this.Project.status=='projectCompleted' || this.Project.status=='projectCancelled'), value: "other", text: 'Other' }
    ];

    console.log( this.selectParams.status.options );

  }



    trackByIndex( index: number, obj: any ): any {
    return index;
  }


  addVideos ( ) {
    this.Project.videos.push( { name: '', before: '', after: '', } );
    this.checkVideos( );
  }

  checkVideos ( ) {
    this.addVideoButtonDisabled = false;
    this.Project.videos.forEach( obj => {
      if ( obj.name == '' ) this.addVideoButtonDisabled = true;
    });
    // this.addVideoButtonDisabled = ( this.editProject.video_before.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeVideos ( _i: number ) {
    this.Project.videos.splice( _i, 1 );
    this.checkVideos( );
  }

  changeTax ( event ) {
    this.Project.tax_id = event.value;
  }


  handleDateDeadlineChange ( $event ) {
    if ( $event === undefined ) return;
    let _date = ( $event.getMonth( ) + 1 ) + '/' + $event.getDate( ) + '/' + $event.getFullYear( );

    this.Project.deadline = _date;
    this._old_deadline = _date;
    this._was_matched_deadline = true;
  }

  changeDatePickerDeadline ( _value, _ref ) {
    if ( _value === undefined ) return;

    _ref.Project.deadline = '';

    if ( _value.match( /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/ ) ) {
      if ( _value != _ref._old_deadline ) {
        _ref._old_deadline = _value;
        _ref._was_matched_deadline = true;
        _ref.Project.deadline = _value;
      }
    } else {
      if ( _ref._was_matched_deadline == true ) {
        _ref._old_deadline = _value;
        _ref._was_matched_deadline = false;
      }
    }
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/add-or-edit/add-or-edit-project.ts